import React from "react";

export const defaultSearchBarStyle = {
    height: "30px",
    width: "25vw",
    margin: "20px",
    float: 'right',
    backgroundColor: "#edf4f9"
} ;

export const defaultTopLeftCellStyle = "5px 0px 0px 0px" ;
export const defaultTopRightCellStyle = "0px 5px 0px 0px" ;

export const defaultTableHeaderStyles = {
    backgroundColor: "#ECF6FD",
    textAlign: "left",
    border: "0",
    fontSize: "14px"
} ;

export const defaultPaginationOptions = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    showTotal: true,
    className: "neil-pager"
};

export const defaultTableOptions = {
striped: true ,
bordered: false,
hover: true,
rowStyle: {
    color: "#605F5E",
    textAlign: "left",
    fontSize: "14px",
    margin: "10px"
}} ;

export const customHeaderStyle = (headerStyles, column, colIndex) => {

    const name = column.dataField ;

    let style = headerStyles.default ;

    if ( headerStyles[name] !== undefined )
    {
        style = { ...style, ...headerStyles[name]} ;
    }

    return style ;
};


